import React, { useEffect, useState } from 'react';
import { resolveMediaUrl } from '../utils/media';

type MediaImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

/**
 * Resolves upload/API image URLs and retries once on transient load failure.
 */
const MediaImage: React.FC<MediaImageProps> = ({ src, onError, ...rest }) => {
  const resolved = resolveMediaUrl(src);
  const [imgSrc, setImgSrc] = useState(resolved);
  const [retried, setRetried] = useState(false);

  useEffect(() => {
    setImgSrc(resolveMediaUrl(src));
    setRetried(false);
  }, [src]);

  return (
    <img
      {...rest}
      src={imgSrc || undefined}
      onError={(e) => {
        if (!retried && imgSrc) {
          setRetried(true);
          const sep = imgSrc.includes('?') ? '&' : '?';
          setImgSrc(`${imgSrc}${sep}_r=${Date.now()}`);
          return;
        }
        onError?.(e);
      }}
    />
  );
};

export default MediaImage;
